import axios from "axios";
import { addDoc, collection, doc } from "firebase/firestore";
import { toast } from "react-hot-toast";
import { db } from "../../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../firebase";

export const createNewOwner = async (
  data,
  companyName,
  phNumber,
  mails,
  addresses,
  reports,
  filteredNotes,
  files
) => {
  const companiesRef = collection(db, "companies");
  const companyDocRef = doc(companiesRef, companyName);
  const ownerRef = collection(companyDocRef, "owners");

  try {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (value === undefined) {
        data[key] = "";
      }
    });

    const uniqueIds = {}; // Helper object to keep track of seen ids
    const imagesUrl = []; // Helper object to keep track of seen ids
    const uniqueItems = files.filter((item) => {
      // If the id is not in the uniqueIds object, add it and return true
      if (!uniqueIds[item.uid]) {
        uniqueIds[item.uid] = true;
        return true;
      }
      // If the id is already in the uniqueIds object, return false to filter it out
      return false;
    });

    for (const file of uniqueItems) {
      const storageRef = ref(storage, `/files/owners/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      try {
        await uploadTask;
        // File uploaded successfully
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        const fileData = {
          downloadURL: downloadURL,
          id: file.uid,
          name: file.name,
          type: file.type,
          isDefault: false,
        };
        imagesUrl.push(fileData);
        console.log("Download URL for", file.name, ":", downloadURL);
      } catch (error) {
        console.error("Upload error for", file.name, ":", error);
      }
    }

    console.log("files", files);
    console.log("imagesUrlimagesUrlimagesUrl", imagesUrl);

    const federalTax = {
      taxPayerName: data.taxPayerName,
      useCompanyName: data.useCompanyName,
      taxPayerId: data.taxPayerId,
    };

    if (data.send099) {
      federalTax.sendingPreference = data.sendingPreference;
      federalTax.receiveElectronic = data.receiveElectronic;
    }

    const ownerCreatedId = await addDoc(ownerRef, {
      ownerInfo: {
        salutation: data.salutation,
        firstName: data.firstName,
        lastName: data.lastName,
        companyName: data.companyName,
        useCompanyNameAsDisplay: data.useCompanyNameAsDisplay,
        tags: [...data.tags],
      },
      accountingInfo: {
        consolidateChecks: data.consolidateChecks,
        holdPayments: data.holdPayments,
        emailCheckReceipt: data.emailCheckReceipt,
        defaultCheckMemo: data.defaultCheckMemo,
      },
      ownerStatement: {
        showTransactionsDetail: data.showTransactionsDetail || "",
        showUnpaidBillsDetail: data.showUnpaidBillsDetail || "",
        showTenantNames: data.showTenantNames || "",
        showSummary: data.showSummary || "",
        separateManagementFeeFromCashOut:
          data.separateManagementFeeFromCashOut || "",
        notesForOwners: data.notesForOwners || "",
      },
      contact: {
        phoneNumbers: phNumber,
        addresses: addresses,
        emails: mails,
      },
      ownerPackets: {
        includedReports: reports,
        sendViaEmail: data.sendViaEmail,
        includePaidWorkOrders: data.includePaidWorkOrders,
        includePaidWorkOrderAttachments: data.includePaidWorkOrderAttachments,
        includePaidBillsAttachments: data.includePaidBillsAttachments,
        glAccountMap: data.glAccountMap,
      },
      federalTax,
      notes: filteredNotes,
      attachments: imagesUrl ? imagesUrl : [],
    });

    console.log("New owner created successfully!");
    if (ownerCreatedId.id) {
      try {
        const ownerData = {
          email: data.email0,
          firstName: data.firstName,
          lastName: data.lastName,
          role: "owner",
          companyName: companyName,
          ownerId: ownerCreatedId.id,
        };
        console.log("database send:", ownerData);
        try {
          const response = await axios.post(
            "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/owner-user",
            ownerData
          );
          console.log(response.data); // User created successfully
          toast.success("owner created successfully");
          // navigate("/");
        } catch (error) {
          console.error("Error creating user:", error);
          const errorMessage = error.message;
          toast.error(errorMessage);
        }
      } catch (error) {
        const errorMessage = error.message;
        toast.error(errorMessage);
      }
    }
  } catch (error) {
    console.error("Error creating new owner:", error);
  }
};
